/** Map stable resume ids to current row indices (survives sort/reorder). */
export function resumeIdsToRowIndices<T extends { id: string }>(
  rows: T[],
  selectedIds: Set<string>,
): Set<number> {
  const indices = new Set<number>()
  rows.forEach((row, index) => {
    if (selectedIds.has(row.id)) {
      indices.add(index)
    }
  })
  return indices
}

/** Convert a Table row-index selection to stable resume ids. */
export function rowIndicesToResumeIds<T extends { id: string }>(
  rows: T[],
  indices: Set<number>,
): Set<string> {
  const ids = new Set<string>()
  indices.forEach((index) => {
    const row = rows[index]
    if (row) {
      ids.add(row.id)
    }
  })
  return ids
}
